import React from "react";
import { Box, CardMedia, makeStyles, Typography } from "@material-ui/core";
import photo from "../../../assets/aboutUs/about3.png";

const useStyles = makeStyles(({ breakpoints, spacing, palette }) => ({
  container: {
    display: "grid",
    gridTemplateColumns: "65% 35%",
    overflow: "hidden",
  },
  text: {
    display: "grid",
    gridTemplateRows: "70% 30%",
  },
  paragraph: {
    alignSelf: "end",
    justifySelf: "end",
    margin: spacing(3),
    fontWeight: 300,
    fontSize: "16px",
    lineHeight: "18px",
    color: "#272727",
    width: "50%",
    textAlign: "end",
  },
  year: {
    justifySelf: "end",
    margin: spacing(3),
    color: "#272727",
    fontWeight: "bold",
    fontSize: "200px",
    lineHeight: "100%",
  },
}));

const about3 = () => {
  const classes = useStyles();

  return (
    <Box component="div" className={classes.container}>
      <Box component="div" className={classes.text}>
        <Typography p="true" className={classes.paragraph}>
          Don Manuel Ventura decide viajar a México que para ese momento estaba
          mucho más industrializado en la industria de velas. Compró más
          máquinas y se especializó en temas de producción, además de tomar
          ideas sobre las nuevas tendencias y modelos. Las nuevas máquinas
          requerían más espacio, así que empieza a comprar terrenos aledaños a
          su vivienda para instalarlas y ampliar la producción. Formalmente
          debía contratar personal para operar las máquinas y poder surtir las
          demandas del mercado, por lo que decide apoyar a jóvenes originarios
          de la misma aldea en la que él había crecido, dándoles oportunidades
          de trabajo y vivienda. Dentro de las nuevas tendencias había un vaso
          de vidrio fabricado en México, y en lugar de importarlo, decide
          negociar con VICAL (Industria fabricante de vidrios para Centroamérica
          con planta de producción en Guatemala), para que fueran ellos quienes
          lo fabricaran. Al día de hoy, ese vaso es uno de los productos más
          vendidos en la industria de velas, generando impacto en la industria
          nacional. También regresó de México con la devoción a la Virgen de
          Guadalupe, por lo que nuevamente acudió a VICAL y solicitó que le
          decoraran algunos vasos con la imagen de la Virgen, basando el diseño
          en la imagen original mexicana. Desde ese momento, en 1984 no se ha
          cambiado el diseño y es requerido por muchas personas por el toque de
          nostalgia que representa.
        </Typography>
        <Typography className={classes.year} variant="h3">
          80s
        </Typography>
      </Box>
      <Box component="div" className={classes.images}>
        <CardMedia className={classes.img} component="img" image={photo} />
      </Box>
    </Box>
  );
};

export default about3;
